export default "__VITE_ASSET__GLqBLGaC__"